import { Suspense } from "react";
import {
  BellIcon,
  BottomSheet,
  BottomSheetHead,
  IconButton,
} from "@songtradr-one/components-frontend";
import {
  BellWrapper,
  MobileSheet,
  MobileTabs,
  NotificationDot,
  Props,
  text,
  useNotificationsPanel,
  useNotificationsQueryRef,
} from "./NotificationsPanel.Parts";
import { NotificationsPanelList } from "./notifications-panel-list/NotificationsPanelList";
import { NotificationsPanelListSkeleton } from "./notifications-panel-list/NotificationsPanelList.Skeleton";
import { NotificationsPanelTabs } from "./notifications-panel-tabs/NotificationsPanelTabs";

const NotificationsPanelMobile = ({ queryRef }: Props) => {
  const { unread, open, setOpen, activeTab, setActiveTab } =
    useNotificationsPanel(queryRef);

  return (
    <>
      <IconButton $small onClick={() => setOpen((prev) => !prev)}>
        <BellWrapper>
          <BellIcon role="img" aria-label="Toggle Notifications" />
          {unread > 0 && <NotificationDot />}
        </BellWrapper>
      </IconButton>
      <BottomSheet open={open} onOpenChange={setOpen} hiddenTitle={text.title}>
        <BottomSheetHead
          title={text.title}
          hasHandle
          onClose={() => setOpen(false)}
        />
        <MobileSheet>
          <MobileTabs>
            <NotificationsPanelTabs
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              unread={unread}
            />
          </MobileTabs>
          <Suspense fallback={<NotificationsPanelListSkeleton />}>
            <NotificationsPanelList
              activeTab={activeTab}
              onNavigate={() => setOpen(false)}
            />
          </Suspense>
        </MobileSheet>
      </BottomSheet>
    </>
  );
};

// WRAPPER
export const NotificationsPanelMobileWrapper = () => {
  const queryRef = useNotificationsQueryRef();

  return (
    <Suspense
      fallback={
        <IconButton disabled $small>
          <BellWrapper>
            <BellIcon role="img" aria-label="Toggle Notifications Fallback" />
          </BellWrapper>
        </IconButton>
      }
    >
      <NotificationsPanelMobile queryRef={queryRef} />
    </Suspense>
  );
};
